import { render, staticRenderFns } from "./packageDetalisPopUp.vue?vue&type=template&id=d26d5a24&"
import script from "./packageDetalisPopUp.vue?vue&type=script&lang=ts&setup=true&"
export * from "./packageDetalisPopUp.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./packageDetalisPopUp.vue?vue&type=style&index=0&id=d26d5a24&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports